<template>
    <div class="report-assesment">
        <ReportsTables  v-on:autoFill="autoFill"/>
    </div>
</template>

<script>
    import ReportsTables from "@/ReportAssesments/ReportsTables.vue";  
    export default {
        name: "ReportsTable", 
        components: {
            ReportsTables
        },
        methods:{
            autoFill(data){
                this.$emit('autoFill',data)
            }
        }
    }
</script>